/**
 * Confirmation Modal Component
 * Modern modal for confirmations and alerts
 */

import { Icon } from "@/components/ui";
import styles from "./ConfirmModal.module.css";

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: "info" | "warning" | "danger" | "success";
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * ConfirmModal component
 */
export function ConfirmModal({
  isOpen,
  title,
  message,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  type = "info",
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case "warning":
        return <Icon name="bell" size={48} />;
      case "danger":
        return <Icon name="xCircle" size={48} />;
      case "success":
        return <Icon name="checkCircle" size={48} />;
      default:
        return <Icon name="bell" size={48} />;
    }
  };

  const getIconColor = () => {
    switch (type) {
      case "warning":
        return "#f59e0b";
      case "danger":
        return "#ef4444";
      case "success":
        return "#10b981";
      default:
        return "#3b82f6";
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={onCancel}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.iconContainer} style={{ color: getIconColor() }}>
          {getIcon()}
        </div>

        <div className={styles.textContent}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.message}>{message}</p>
        </div>

        <div className={styles.actions}>
          <button className={styles.cancelButton} onClick={onCancel}>
            {cancelText}
          </button>
          <button
            className={`${styles.confirmButton} ${styles[type]}`}
            onClick={() => {
              onConfirm();
              onCancel();
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
